<div class="modal-content email-add-sender-modal-content">
  <div class="modal-header">
    <h5 class="modal-title">{{ title }}</h5>
    <button type="button" class="close" (click)="cancelEvent.emit()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="t-1">
      <div class="toastr-relative toastr-sm toastr-no-shadow my-4 custom-alert" toastContainer></div>
    </div>
    <form [formGroup]="addEmailSenderForm">
      <div class="page__form-wrap">
        <div class="d-flex justify-content-center custom-div">
          <label for="sender" class="col-sm-4" translate="mail_user_add_input"></label>
          <div class="col-sm-6">
            <input type="text" class="form-control" id="sender" formControlName="sender" />
            <wsb-validation-error-msg [fc]="addEmailSenderForm.get('sender')"></wsb-validation-error-msg>
          </div>
          <!-- <div class="col-sm-2"> -->
          <label for="domain">&#64;</label>
          <!-- </div> -->
          <div class="col-sm-6">
            <ng-select
              [ngClass]="{ 'disabled-class ': listEmailDomain.length === 0 }"
              id="domain"
              formControlName="domain"
              [items]="listEmailDomain"
              bindLabel="domain"
              bindValue="domain"
              [clearable]="false"
              class="form-control"
            >
            </ng-select>
          </div>
        </div>
      </div>
    </form>
  </div>
  <div class="modal-footer">
    <wsb-atlas-button
      variant="secondary"
      class="secondary me-3"
      data-dismiss="modal"
      (btnClick)="cancelEvent.emit()"
      [label]="labelCancelButton"
    ></wsb-atlas-button>
    <wsb-atlas-button
      variant="primary"
      [disabled]="addEmailSenderForm.pristine || addEmailSenderForm.invalid || listEmailDomain.length === 0"
      (btnClick)="save.emit(getFormValue())"
      [label]="labelSaveButton"
    ></wsb-atlas-button>
  </div>
</div>
